import SeoHead from "@/Component/Seo/SeoHead";
import TermsCondition from "@/Component/Module/TermsCondition";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function TermsAndConditionPage({ seo, seoCountry }) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Terms & Conditions | Next Holidays"
      />
      <TermsCondition />
    </>
  );
}

export async function getServerSideProps(context) {
  const seoResult = await fetchPageSeo(context, {
    path: "/termsandcondition",
  });

  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
    },
  };
}
